import Link from 'components/Navigation/WrapperLink'

export default function NoOffers() {
  return (
    <>
      <p className="small">Sinulla ei ole vielä tarjouspyyntöjä!</p>
      <br />
      <br />
      <p className="small">Etsi juuri sinulle täydellinen tapahtuma.</p>
      <br />
      <Link data={{ slug: '/tapahtumat', type: 'event_archive' }}>
        <button className="btn btn--primary">Etsi tapahtumia</button>
      </Link>
    </>
  )
}
